import { render, staticRenderFns } from "./InspectionStatusLabel.vue?vue&type=template&id=15f3a515&scoped=true&"
import script from "./InspectionStatusLabel.vue?vue&type=script&lang=ts&"
export * from "./InspectionStatusLabel.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionStatusLabel.vue?vue&type=style&index=0&id=15f3a515&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3a515",
  null
  
)

export default component.exports